// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.slider {
    display:inline-block; 
    width: 100px;
}

.gauge {
    display: inline-block;
    position: absolute;
    top: 0px;
    width: 360px;
    height: 350px;
    margin: 0 auto;
    padding-top: 30px;
    padding-left: 70px;
}

.gauge-select {
    width: 280px; 
    text-align: center;
}

.gauge-view {
    border: 1px solid var(--formSeparatorColor);
    width: 280px; 
    height: 220px;
    margin-top: -5px;
    padding-top: 30px;
}

.btn-gauge {
    z-index: 99;
    display: inline-block;
    width: 50px;
    height:38px;
    border: 1px solid var(--formSeparatorColor);
}

.btn-gauge-mat {
    background: url('/assets/images/gauge-mat.png') no-repeat center center;
    background-size: 45px 30px;
}

.btn-gauge-donut {
    background: url('/assets/images/gauge-donut.png') no-repeat center center;
    background-size: 52px 28px;
} 

.btn-gauge-zone {
    background: url('/assets/images/gauge-zone.png') no-repeat center center;
    background-size: 45px 30px;
}

.toolbox {
    position: absolute;
    width: 100%;
    height: 310px;
}

.toolbox-left {
    display: inline-block;
    width: 460px;
    padding-top: 20px;
}

.toolbox-right {
    width: 300px;
    position: absolute;
    top: 0px;
    right: 0px;
    height: 270px;
}

.toolbox-det {
    display: inline-block;
    width: 312px;
    height: 300px;
    position: absolute;
    top: 15px;
    right: 0px;
}

.slider-field span {
    padding-left: 2px;
    text-overflow: clip;
    max-width: 125px;
    white-space: nowrap;
    overflow: hidden;
}

.slider-field mat-slider {
    background-color: var(--formSliderBackground);
    height: 30px;
}

.field-row {
    display: block;
    margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-bag/bag-property/bag-property.component.css"],"names":[],"mappings":";AACA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,uEAAuE;IACvE,0BAA0B;AAC9B;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;AAC9B;;AAEA;IACI,wEAAwE;IACxE,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":["\n.slider {\n    display:inline-block; \n    width: 100px;\n}\n\n.gauge {\n    display: inline-block;\n    position: absolute;\n    top: 0px;\n    width: 360px;\n    height: 350px;\n    margin: 0 auto;\n    padding-top: 30px;\n    padding-left: 70px;\n}\n\n.gauge-select {\n    width: 280px; \n    text-align: center;\n}\n\n.gauge-view {\n    border: 1px solid var(--formSeparatorColor);\n    width: 280px; \n    height: 220px;\n    margin-top: -5px;\n    padding-top: 30px;\n}\n\n.btn-gauge {\n    z-index: 99;\n    display: inline-block;\n    width: 50px;\n    height:38px;\n    border: 1px solid var(--formSeparatorColor);\n}\n\n.btn-gauge-mat {\n    background: url('/assets/images/gauge-mat.png') no-repeat center center;\n    background-size: 45px 30px;\n}\n\n.btn-gauge-donut {\n    background: url('/assets/images/gauge-donut.png') no-repeat center center;\n    background-size: 52px 28px;\n} \n\n.btn-gauge-zone {\n    background: url('/assets/images/gauge-zone.png') no-repeat center center;\n    background-size: 45px 30px;\n}\n\n.toolbox {\n    position: absolute;\n    width: 100%;\n    height: 310px;\n}\n\n.toolbox-left {\n    display: inline-block;\n    width: 460px;\n    padding-top: 20px;\n}\n\n.toolbox-right {\n    width: 300px;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    height: 270px;\n}\n\n.toolbox-det {\n    display: inline-block;\n    width: 312px;\n    height: 300px;\n    position: absolute;\n    top: 15px;\n    right: 0px;\n}\n\n.slider-field span {\n    padding-left: 2px;\n    text-overflow: clip;\n    max-width: 125px;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.slider-field mat-slider {\n    background-color: var(--formSliderBackground);\n    height: 30px;\n}\n\n.field-row {\n    display: block;\n    margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
